import { Download, Mail, Phone, MapPin } from "lucide-react"
import Header from "../components/Header"
import Footer from "../components/Footer"

export default function SupportPage() {

  return (
    <div className="min-h-screen bg-white">
      <Header scrollThreshold={400} />
      {/* Hero Section */}
      <section className="relative h-[400px] bg-gray-900 overflow-hidden pt-[60px] font-titillium">
        {/* Background Image */}
        <div className="absolute inset-0 w-full h-[440px]
        bg-[url('@/assets/images/support-banner.png')] bg-center bg-no-repeat bg-cover"></div>

        {/* Hero Content */}
        <div className="relative z-10 max-w-7xl mx-auto px-4 h-full flex items-center">
          <div>
            <h1 className="text-[40px] font-bold text-white leading-tight">
              iData is dedicated to providing the support
                <br />
              our customers require precisely when they need it.
            </h1>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4">
          <h2 className="text-[40px] text-[#161616] mb-12">Support</h2>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {/* FAQ Document */}
            <div className="bg-[#f3f3f3] rounded-lg shadow-sm p-[24px] hover:shadow-md transition-shadow relative h-[314px]">
              <div>
                <h3 className="text-xl font-semibold text-gray-900 mb-4">FAQ Document</h3>
                <p className="text-[16px] text-[#4D4D4D] leading-relaxed">
                  Access the most commonly asked questions from customers about our products.
                </p>
                <div className="w-16 h-16 rounded-full
                justify-center absolute left-[24px] bottom-[24px]
                bg-[url('@/assets/images/download-icon.svg')] hover:bg-[url('@/assets/images/download-icon-hover.svg')]
                cursor-pointer" onClick={() => { window.open('/assets/files/FAQ-alpha_factor_database.pdf', '_blank')}}>
                </div>
              </div>
            </div>

            {/* Data Download Tutorial */}
            <div className="bg-[#f3f3f3] rounded-lg shadow-sm p-[24px] hover:shadow-md transition-shadow relative h-[314px]">
              <div>
                <h3 className="text-xl font-semibold text-gray-900 mb-4">Data Download Tutorial</h3>
                <p className="text-[16px] text-[#4D4D4D] leading-relaxed">
                  Find guides on how to download the required files from the server safely and efficiently via SFTP (SSH
                  File Transfer Protocol).
                </p>
                <div className="w-16 h-16 rounded-full
                justify-center absolute left-[24px] bottom-[24px]
                bg-[url('@/assets/images/download-icon.svg')] hover:bg-[url('@/assets/images/download-icon-hover.svg')]
                cursor-pointer" onClick={() => { window.open('/assets/files/Data-Synchronization-Program-Client-Guidance-English-version.pdf', '_blank')}}>
                </div>
              </div>
            </div>

            {/* Contact Us */}
            <div className="bg-[#f3f3f3] rounded-lg shadow-sm p-[24px] hover:shadow-md transition-shadow h-[314px]">
              <div className="mb-6">
                <h3 className="text-xl font-semibold text-gray-900 mb-4">Contact Us</h3>
                <p className="text-[16px] text-[#4D4D4D] leading-relaxed">
                  If you have any problems, we encourage you to submit a request for support on our customer service
                  webpage.
                </p>

                <div>
                  <div className="text-[16px] text-[#4D4D4D]">CONTACT US</div>
                  <div className="flex items-center space-x-3 text-[#4D4D4D]">
                    <span className="text-[16px]">Email: contacts@idatausa.com</span>
                  </div>

                  <div className="flex items-center space-x-3 text-[#4D4D4D]">
                    <span className="text-[16px]">Tel: (+1) 302-386-8402</span>
                  </div>

                  <div className="flex items-start space-x-3 text-[#4D4D4D]">
                    <span className="text-[16px]">Address:418 Broadway, #5095, Albany, NY 12207</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  )
}
